import { getDriverMobileRequest } from "../../data/driverMobileApi";

export async function getDriverMobileUseCase(driverId) {
  if (!Number.isSafeInteger(driverId) || driverId <= 0) {
    return { success: false, data: null, error: "El conductor no es válido." };
  }

  const result = await getDriverMobileRequest(driverId);
  if (!result.success) return result;

  const driver = result.data?.driver;
  if (!driver) {
    return {
      success: false,
      data: null,
      error: "No se pudo cargar la información del conductor.",
    };
  }

  return {
    success: true,
    data: {
      name: driver.name,
      lastname: driver.lastname,
      vehicles: Array.isArray(result.data.vehicles)
        ? result.data.vehicles.map(({ id, plate, model }) => ({ id, plate, model }))
        : [],
    },
    error: null,
  };
}
